import React, { Suspense, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { isMobile } from 'react-device-detect';
import { Container } from '@mui/material';
import { InvoiceModel } from 'models/InvoiceModel';
import InvoiceForm from 'modules/invoices/common/InvoiceForm';
import useInvoices from 'modules/invoices/hooks/useInvoices';
import useInvoiceModals from 'modules/invoices/hooks/useInvoiceModals';
import auth from 'recoil/atoms/auth';


const InvoiceInner = () => {
    const my = useRecoilValue(auth);
    const modals = useInvoiceModals();
    const {createInvoice} = useInvoices();
    const [invoice, setInvoice] = useState<InvoiceModel>();

    const save = () => {

    };

    return (
        <Container maxWidth="md" disableGutters={isMobile}>
            <InvoiceForm
                invoice={invoice}
                update={setInvoice}
                save={save}
            />
        </Container>
    );
};

const InvoiceCreate = () => {
    return (
        <Suspense fallback={null}>
            <InvoiceInner/>
        </Suspense>
    )
};

export default InvoiceCreate;
